import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './EmptyState.module.css';
export const EmptyState = ({ type, onNewMessage }) => {
    const getContent = () => {
        switch (type) {
            case 'contact':
                return {
                    image: '/images/empty-state-message.png',
                    title: 'Send a Message',
                    subtitle: 'Have a question? Send us a message here.',
                    showButton: true,
                };
            case 'quotes':
                return {
                    image: '/images/empty-state-message.png',
                    title: 'Quote Chat is empty',
                    subtitle: 'If you have any questions about a quote, select it to the left and chat with us here.',
                    showButton: false,
                };
            case 'jobs':
                return {
                    image: '/images/empty-state-message.png',
                    title: 'Job Chat is empty',
                    subtitle: 'If you have any questions about a job, select it to the left and chat with us here.',
                    showButton: false,
                };
        }
    };
    const content = getContent();
    return (_jsxs("div", { className: styles.container, children: [_jsx("img", { className: styles.image, src: content.image, alt: content.title }), _jsx("h2", { className: styles.title, children: content.title }), _jsx("p", { className: styles.subtitle, children: content.subtitle }), content.showButton && onNewMessage && (_jsxs("button", { className: styles.button, onClick: onNewMessage, children: [_jsx("span", { children: "+" }), _jsx("span", { children: "New Message" })] }))] }));
};
